import script from "./herder.vue?vue&type=script&setup=true&lang=js"
export * from "./herder.vue?vue&type=script&setup=true&lang=js"

import "./herder.vue?vue&type=style&index=0&id=07b683d8&lang=scss&scoped=true"

import exportComponent from "D:\\Leo\\Frontend\\surveys\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b683d8"]])

export default __exports__